export default __webpack_public_path__ + "static/media/logoMobile.e812bd57.svg";